import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './LanguageContext';
import { loadRuntimeConfig } from './config/runtimeConfig';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

loadRuntimeConfig()
  .then(() => {
    root.render(
      <React.StrictMode>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </React.StrictMode>,
    );
    reportWebVitals();
  })
  .catch((error) => {
    console.error('Failed to load runtime configuration', error);
  });
